<template>
  <div class="scroll-section">
    <div class="animated-bg">
      <div class="construction-bg">
        <img :src="bg" alt="">
      </div>
      <div class="cables-outer">
        <div class="cables" :style="'background-image: url('+cables+');'"></div>
      </div>
      <div class="animated-binaries">
        <div class="bin-svg" v-for="(idx, val) in oc_binary_sequence" :key="idx + '-' + val + '-blog'" :class="'_'+idx">
          <img :src="binary_bgs[idx]" alt="">
        </div>
      </div>
      <div class="construction-fg">
        <img :src="fg" alt="">
      </div>
      <div class="cable-glow">
        <img :src="glow" alt="">
      </div>
    </div>
    <div class="container">
      <div class="columns">
        <div class="column is-7">
          <div class="section-content animate">
            <h1>{{ $t('blog.heading') }}</h1>
            <div class="paragraph" v-html="$t('blog.paragraph')"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import binSvg1 from '../.././assets/bin-1.svg'
import binSvg0 from '../.././assets/bin-0.svg'
import sectionBg from '../.././assets/construction-bg.svg'
import sectionFg from '../.././assets/construction-fg.svg'
import netCables from '../.././assets/constructions-cables.png'
import cableGlow from '../.././assets/cable-glow.svg'
import {mapGetters, mapActions} from 'vuex'
import {isElementVisible} from '../../useElementVisible.js'

export default {
  name: 'Blog',
  data() {
    return {
      exclude_from_nav: true,
      nav_title: 'our_blog',
      bg: sectionBg,
      fg: sectionFg,
      cables: netCables,
      glow: cableGlow,
      binary_bgs: [
        binSvg0,
        binSvg1
      ],
      bin_timelines: [],
      bin_num_rows: 8,
      oc_binary_sequence: [
        0, 1, 1, 0, 1, 1, 1, 1,
        0, 1, 1, 0, 1, 1, 1, 0,
        0, 1, 1, 0, 1, 1, 0, 0,
        0, 1, 1, 0, 1, 0, 0, 1,
        0, 1, 1, 0, 1, 1, 1, 0
        // 0, 1, 1, 0, 0, 1, 0, 1
      ]
    }
  },
  mounted() {
    this.hideElements()
    this.addBinTimelines()

    isElementVisible(this.$el, () => {
      this.runSectionAnimations()
    }).attachDefaultEvents()

  },
  watch: {
    active_section_name(val) {
      if (val === this.$options._componentTag) {
        if (!this.is_animating_scroll) {
          this.runSectionAnimations()
        }
      }
    },
    scroll_pos(val) {
      if (this.scroll_pos > (this.$el.offsetTop - 350) && this.scroll_pos < ((this.elHeight - 200) + this.$el.offsetTop)) {
        if (!this.is_animating_scroll) {
          this.setActiveSection(this.$options._componentTag)
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      active_section_name: 'getActiveSectionName',
      scroll_pos: 'getScrollPos',
      is_animating_scroll: 'getAnimatingScrollState'
    }),
    elHeight() {
      return Math.ceil(this.$el.getBoundingClientRect().height)
    }
  },
  methods: {
    ...mapActions([
      'setActiveSection'
    ]),
    hideElements() {
      if (window.ieLegacy()) {
        return
      }
      let elements = this.$el.querySelectorAll('.animate')
      TweenMax.set(elements, {
        autoAlpha: 0
      })
    },
    getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min
    },
    addBinTimelines() {
      for (let i = 0; i < this.oc_binary_sequence.length; i++) {
        let BinSvgs = this.$el.querySelectorAll('.bin-svg')
        TweenMax.set(BinSvgs[i], {
          transformOrigin: 'bottom',
          autoAlpha: 0,
          scale: 0.2
        })
        let rowIndex = Math.floor(i / this.bin_num_rows)
        let ttl = new TimelineMax({
          repeat: -1,
          delay: ((i % this.bin_num_rows) % 2 === 0) ? rowIndex * 0.8 : rowIndex * 0.8 + 0.4
        })
        let riseTime = 3.6// this.getRandomArbitrary(1.6, 3)
        let fadeOut = riseTime - 0.4
        ttl.set(BinSvgs[i], {
          y: 0,
          x: (i % this.bin_num_rows) * 240 + '%'
        }).to(BinSvgs[i], 0.3, { // Fade in
          autoAlpha: this.getRandomArbitrary(0.6, 1),
          ease: Power3.easeInOut
        }).fromTo(BinSvgs[i], 0.3, { // Pop up before rising
          y: 0
        }, {
          y: -60,
          ease: Power0.easeNone
        }, 0).fromTo(BinSvgs[i], 0.7, {
          scale: 0.2
        }, {
          scale: this.getRandomArbitrary(0.8, 1),
          ease: Power3.easeOut
        }, 0.2).fromTo(BinSvgs[i], riseTime, {
          y: -60
        }, {
          bezier: { // wave side to side
            type: 'soft',
            values: [
              {x: '+=' + this.getRandomArbitrary(15, 30), y: -90},
              {x: '-=' + this.getRandomArbitrary(15, 30), y: -160},
              {x: '+=' + this.getRandomArbitrary(15, 30), y: -210},
              {x: '-=' + this.getRandomArbitrary(15, 30), y: -260}
            ]
          },
          ease: Power0.easeNone
        }, 0.3).to(BinSvgs[i], 0.6, {
          autoAlpha: 0
        }, fadeOut)

        ttl.pause()
        this.bin_timelines.push(ttl)
      }
    },
    runSectionAnimations() {
      if (this.animationsInit) return

      this.bin_timelines.forEach((tl) => {
        tl.play()
      })

      let cableGlow = this.$el.querySelector('.cable-glow')
      TweenMax.fromTo(cableGlow, 0.25, {
        alpha: 0.8,
        scale: 0.85
      }, {
        alpha: 0.9,
        scale: 1,
        ease: Power1.easeInOut,
        repeat: -1,
        yoyo: true
      }, 0)

      let column = this.$el.querySelector('.section-content')
      TweenMax.to(column, 0.3, {
        autoAlpha: 1
      })
      TweenMax.fromTo(column, 1, {
        x: 100
      }, {
        x: 0,
        ease: Power2.easeInOut
      })
      this.animationsInit = true
    }
  }
}
</script>

<style lang="postcss">
.bg-gradient {
  background: ease-out-sine-gradient(#d5edef,
  transparent);
}
</style>

<style lang="scss" scoped>
.scroll-section {
  padding-top: 110px;
  background-color: #a1bed4;
  position: relative;
  z-index: 1;
  overflow: hidden;
  @media screen and (max-width: 768px) {
    padding-top: 33%;
  }
  @media screen and (max-width: 480px) {
    padding-top: 290px;
  }
}

.container {
  position: absolute;
  top: 8%;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
}

.animated-bg {
  position: relative;
  width: 100%;
  @media screen and (max-width: 1024px) {
    padding-bottom: 24px;
  }

  .construction-bg {
    width: 100%;
    text-align: right;

    > img {
      width: 100%;
      margin-bottom: -2rem;
    }
  }

  .construction-fg {
    position: absolute;
    width: 100%;
    top: 0;
  }
}

.column {
  position: relative;
  z-index: 2;
  text-align: right;
  @media screen and (max-width: 480px) {
    text-align: left;
  }
}
</style>

<style lang="scss">
.section-content {
  color: #343434;

  > h1 {
    font-size: 3rem;
    text-transform: uppercase;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 1.3rem;
    @media screen and (max-width: 1200px) {
      font-size: 2.3rem;
      line-height: 1.1;
    }
    @media screen and (max-width: 1024px) {
      font-size: 2rem;
    }
  }

  .paragraph {
    h5 {
      font-size: 1.3rem;
      margin-bottom: 2rem;
      @media screen and (max-width: 1024px) {
        font-size: 1.15rem;
        margin-bottom: 1.7rem;
      }
      @media screen and (max-width: 480px) {
        font-size: 1rem;
        margin-bottom: 1.5rem;
      }
    }

    a {
      color: #ff7c4e;
      font-weight: 500;

      &:hover {
        color: #ff7c4e;
        text-decoration: underline;
      }
    }
  }
}

.animated-binaries {
  width: 30%;
  position: absolute;
  right: 21%;
  top: 61%;
  @media screen and (max-width: 480px) {
    display: none;
  }
}

.bin-svg {
  width: 4%;
  position: absolute;
  backface-visibility: hidden;

  > img {
    backface-visibility: hidden;
  }
}

.cables-outer {
  width: 37%;
  position: absolute;
  right: 22%;
  top: 47%;

  .cables {
    width: 100%;
    padding-bottom: 40%;
    background-size: 100%;
    background-repeat: no-repeat;
  }
}

.cable-glow {
  position: absolute;
  width: 100%;
  right: 0;
  top: 3%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/sections/Blog.vue